import {useLogger, useUniversalFetch, useUniversalPut} from '#imports';

export interface FeatureFlag {
    feature: string;
    isEnabledForUser: boolean;
    isCanBeModifiedForUser: boolean;
}

/**
 * Admin-only API to list every feature flag and toggle their state.
 */
export function useFeatureFlagAdminApi() {
    const logger = useLogger();

    async function fetchAllFeatureFlags(): Promise<FeatureFlag[]> {
        const endpoint = '/api/feature-flipping';

        try {
            return await useUniversalFetch<FeatureFlag[]>(endpoint);
        } catch {
            logger.error('Error while fetching all feature flags.');
        }
        return [];
    }

    async function switchStateFeatureFlag(featureFlagId: string, isEnabled: boolean): Promise<void> {
        const endpoint = `/api/feature-flipping/${featureFlagId}/state`;

        try {
            await useUniversalPut<void>(endpoint, {
                query: {enabled: isEnabled},
            });
        } catch {
            logger.error(`Error while changing status of FF "${featureFlagId}".`);
        }
    }

    return {
        fetchAllFeatureFlags,
        switchStateFeatureFlag,
    };
}
